// extracted by mini-css-extract-plugin
module.exports = {"list":"facet-ActiveFacets__list--2a6nN"};